module.exports = __webpack_public_path__ + "media/images/writer/community/pc-title@2x-af14fffd41fd95f33742631599791140.png";